import { Server, contentClient } from '@wajeez-web/core/api-base';
import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';

export const getFlowSelectionsDatatable: ApiMethod<
  Server.FlowSelectionDatatable,
  Server.TableOfFlowSelectionColumns
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_FlowSelections_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_FlowSelections_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getFlowSelectionById: ApiMethod<
  number,
  Server.FlowSelectionOutput
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_FlowSelections_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_FlowSelections_byId_get_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createFlowSelection: ApiMethod<
  Server.CreateFlowSelectionInput,
  number
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_FlowSelections_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_FlowSelections_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editFlowSelection: ApiMethod<
  Server.UpdateFlowSelectionInput,
  number
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_FlowSelections_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_FlowSelections_put_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const changePublishState: ApiMethod<
  Server.SetFlowSelectionPublishStateInput,
  number
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_FlowSelections_Client(
      undefined,
      contentClient
    );

    const response = await client.admin_FlowSelections_publishState_put_V1(
      data
    );

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
